"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var base_exports = {};
__export(base_exports, {
  generateUtilityClass: () => import_generateUtilityClass.generateUtilityClass,
  generateUtilityClasses: () => import_generateUtilityClasses.generateUtilityClasses,
  isGlobalState: () => import_generateUtilityClass.isGlobalState
});
module.exports = __toCommonJS(base_exports);
__reExport(base_exports, require("@mui/base/node"), module.exports);
var import_generateUtilityClass = require("@mui/base/node/generateUtilityClass");
var import_generateUtilityClasses = require("@mui/base/node/generateUtilityClasses");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  generateUtilityClass,
  generateUtilityClasses,
  isGlobalState,
  ...require("@mui/base/node")
});
